import { useSelector } from 'react-redux';

export const MakeFields = () => {
  const { giftCardNumber, problemsGiftcard } = useSelector(
    (state) => state.issuesSlice,
  );

  return [
    {
      name: 'rut',
      inputAdornment: '',
      label: 'RUT',
      disabled: false,
      required: true,
      helper: 'Sin puntos, pero con guión Ej: 12345678-9',
    },
    {
      name: 'clientName',
      inputAdornment: '',
      label: 'Nombre completo',
      disabled: false,
      required: true,
    },
    {
      name: 'phone',
      inputAdornment: '',
      label: 'Teléfono',
      disabled: false,
      required: true,
      helper: 'Ingresar 9 dígitos',
    },
    {
      name: 'email',
      inputAdornment: '',
      label: 'Correo',
      disabled: false,
      required: true,
    },
    {
      name: 'giftCardNumber',
      inputAdornment: '',
      label: 'Nº de Gift Card',
      disabled: true,
      required: true,
      helper: 'Ingresa 7 o 20 dígitos',
      value: giftCardNumber,
    },
    {
      name: 'problemsGiftcard',
      inputAdornment: '',
      label: 'Inconveniente',
      disabled: true,
      required: true,
      value: problemsGiftcard,
      hidden: true,
    },
    {
      name: 'comment',
      inputAdornment: '',
      label: 'Escribir comentario',
      disabled: false,
      required: false,
      rows: 4,
      multiline: true,
    },
  ];
};
